export default __webpack_public_path__ + "static/media/ic_marketplace.fa7b6cc4.png";